import Splide from "@splidejs/splide"
import { sendEvent } from "../global/utils/sendEvent"

export const GenericSlider = (mainSlider) => {
  return {
    slider: null,
    sliderStart: 0,
    eventName: mainSlider?.dataset?.sliderName || "Generic Slider",
    init() {
      this.$nextTick(() => {
        if (!mainSlider) return

        this.slider = new Splide(mainSlider)
        this.sliderStart = this.slider.options?.start || 0

        this.slider.mount()

        this.slider.on("moved", (current, previous) => {
          sendEvent(this.eventName, {
            event_detail: this.isGoingForward(current, previous)
              ? "Advance"
              : "Reverse",
          })
        })
      })
    },
    isGoingForward(current, previous) {
      if (current === 0 && previous === this.slider.length - 1) {
        return true
      } else if (previous === 0 && current === this.slider.length - 1) {
        return false
      } else {
        return previous < current
      }
    },
  }
}
